import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db2a19f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Фильтры", -1))
const _hoisted_2 = { class: "FtlOrdersFilters__row mt-3" }
const _hoisted_3 = {
  key: 0,
  aclass: "text-sm text-gray-400"
}
const _hoisted_4 = { class: "FtlOrdersFilters__actions" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[36] || (_cache[36] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
    class: "FtlOrdersFilters"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_input, {
        value: _ctx.state.id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.id) = $event)),
        placeholder: "Номер заказа",
        "is-invalid": _ctx.state_form$.id.$error,
        "validation-errors": _ctx.state_form$.id.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.dop_invoice_number,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dop_invoice_number) = $event)),
        placeholder: "Номер накл. заказчика"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.created_at_from,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.created_at_from) = $event)),
        type: "date",
        placeholder: "Дата создания с"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.created_at_to,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.created_at_to) = $event)),
        type: "date",
        placeholder: "Дата создания по"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.from_act_date,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.from_act_date) = $event)),
        type: "date",
        placeholder: "Дата АВР от"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.to_act_date,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.to_act_date) = $event)),
        type: "date",
        placeholder: "Дата АВР по"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.company_id) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany
      }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        placeholder: "Статус",
        multiselect: "",
        options: _ctx.STATUSES,
        value: _ctx.state.status,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.status) = $event))
      }, null, 8, ["options", "value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.state.city_from_id,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.city_from_id) = $event)),
        placeholder: "Город отправитель",
        loading: _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1)))
      }, null, 8, ["value", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.state.city_to_id,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.city_to_id) = $event)),
        placeholder: "Город получатель",
        loading: _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1)))
      }, null, 8, ["value", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.state.car_id,
        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.car_id) = $event)),
        placeholder: "Машина",
        loading: _ctx.data_state.cars.is_loading,
        options: _ctx.data_state.cars.list,
        failed: _ctx.data_state.cars.is_failed,
        "error-text": "При получении списка машин произошла ошибка",
        "search-by": "number",
        "select-by": "id",
        "infinite-scroll": "",
        onRefresh: _ctx.loadCars
      }, {
        "selected-option": _withCtx(({ option }) => [
          (option.company)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number) + " (" + _toDisplayString(option.company.name) + ") ", 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
              ], 64))
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1),
            (option.company)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(option.company.name), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["value", "loading", "options", "failed", "onRefresh"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.state.carrier_id,
        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.carrier_id) = $event)),
        placeholder: "Перевозчик",
        label: "name",
        "search-by": "name",
        "select-by": "id",
        options: _ctx.data_state.carriers.list,
        loading: _ctx.data_state.carriers.is_loading,
        failed: _ctx.data_state.carriers.is_failed,
        "error-text": "При получении списка перевозчиков произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _ctx.loadCarriers
      }, null, 8, ["value", "options", "loading", "failed", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        value: _ctx.state.manager_id,
        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.manager_id) = $event)),
        placeholder: "Менеджер",
        loading: _ctx.data_state.managers.is_loading,
        options: _ctx.data_state.managers.list,
        failed: _ctx.data_state.managers.is_failed,
        "error-text": "При получении списка менеджеров произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        onRefresh: _cache[19] || (_cache[19] = ($event: any) => (_ctx.loadManagers(_ctx.data_state.managers.pagination.current_page))),
        onSearch: _ctx.searchManagers,
        onOptionBySearch: _ctx.unshiftFoundManager
      }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        value: _ctx.state.logist_id,
        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.logist_id) = $event)),
        placeholder: "Ответственный логист",
        loading: _ctx.data_state.logists.is_loading,
        options: _ctx.data_state.logists.list,
        failed: _ctx.data_state.logists.is_failed,
        "error-text": "При получении списка логистов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _ctx.loadLogists
      }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        value: _ctx.state.dispatcher_id,
        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.dispatcher_id) = $event)),
        placeholder: "Ответственный диспетчер",
        loading: _ctx.data_state.dispatchers.is_loading,
        options: _ctx.data_state.dispatchers.list,
        failed: _ctx.data_state.dispatchers.is_failed,
        "error-text": "При получении списка диспетчеров произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _ctx.loadDispatchers
      }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.act_number,
        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.act_number) = $event)),
        placeholder: "Номер АВР"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        value: _ctx.state.is_need_car,
        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.is_need_car) = $event)),
        placeholder: "Без авто",
        options: _ctx.WITHOUT_AUTO_OPTIONS,
        searchable: false,
        "select-by": "value"
      }, null, 8, ["value", "options"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        "can-deselect": "",
        placeholder: "Тип ФТЛ",
        multiselect: "",
        searchable: false,
        options: _ctx.FTL_TYPES,
        value: _ctx.state.ftl_types,
        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.ftl_types) = $event))
      }, null, 8, ["options", "value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.take_date,
        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.take_date) = $event)),
        type: "date",
        placeholder: "Дата забора"
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        value: _ctx.state_checkbox.is_today,
        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state_checkbox.is_today) = $event)),
        label: "Сегодня",
        onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCheckboxChange('today')))
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        value: _ctx.state_checkbox.is_yesterday,
        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state_checkbox.is_yesterday) = $event)),
        label: "Вчера",
        onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onCheckboxChange('yesterday')))
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        value: _ctx.state_checkbox.is_this_week,
        "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state_checkbox.is_this_week) = $event)),
        label: "Текущая неделя",
        onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onCheckboxChange('this_week')))
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        value: _ctx.state_checkbox.is_previous_week,
        "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state_checkbox.is_previous_week) = $event)),
        label: "Прошлая неделя",
        onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onCheckboxChange('previous_week')))
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        value: _ctx.state_checkbox.is_this_month,
        "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state_checkbox.is_this_month) = $event)),
        label: "Текущий месяц",
        onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onCheckboxChange('this_month')))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_button, {
        class: "second text small mr-3",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}